<div class="main">
    <div class="loading-shade" *ngIf="isLoading">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>
    <table mat-table [dataSource]="annulusSpaces" class="annulus-spaces-table handover-data-table">
        <ng-container matColumnDef="numAnular">
            <mat-header-cell *matHeaderCellDef> Espacio<br>Anular </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index"> {{annulusSpace.numAnular}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="diamTubInt">
            <mat-header-cell *matHeaderCellDef> Diámetro Tub. <br>Interior [pulg] </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">
                <ng-container>{{annulusSpace.diamTubInt}}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="diamTubExt">
            <mat-header-cell *matHeaderCellDef> Diámetro Tub. <br>Exterior [pulg] </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">
                <ng-container>{{annulusSpace.diamTubExt}}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="hasMeasuredPressure">
            <mat-header-cell *matHeaderCellDef> ¿Registró Dato <br> de Presión? </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">

                <mat-slide-toggle [disabled]="readOnlyContent" [checked]="annulusSpace.hasMeasuredPressure"
                    [(ngModel)]="annulusSpaces[i].hasMeasuredPressure"
                    (change)="enableSaveButton(i); onSectionTouched('annulusSpaces'); cleanDataAssociated(i);" name="hasMeasuredPressure">
                    {{annulusSpace.hasMeasuredPressure ? 'Si' : 'No'}}
                </mat-slide-toggle>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaFin">
            <mat-header-cell *matHeaderCellDef> Fecha de <br>Medición </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">
                <ng-container>{{annulusSpace.fechaFin | date: 'dd/MM/yyyy'}}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="presionCasing">
            <mat-header-cell *matHeaderCellDef> Presión  <br>Medida [psi] </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">
                <ng-container>{{annulusSpace.presionCasing | number: '1.2-2'}} </ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pressureMeasureDate">
            <mat-header-cell *matHeaderCellDef> Fecha de <br> Medición </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">
                <mat-form-field>
                    <input matInput [matDatepicker]="pressureMeasureDate"
                        [readonly]="readOnlyContent"
                        [(ngModel)]="annulusSpaces[i].pressureMeasureDate"
                        [disabled]="!annulusSpace.hasMeasuredPressure"
                        (dateChange)="enableSaveButton(i); onSectionTouched('annulusSpaces')"
                        name="pressureMeasureDate">
                    <mat-datepicker-toggle matSuffix [disabled]="readOnlyContent" [for]="pressureMeasureDate"></mat-datepicker-toggle>
                    <mat-datepicker #pressureMeasureDate></mat-datepicker>
                    <mat-hint class="alert" *ngIf="annulusSpace.hasMeasuredPressure && !readOnlyContent">
                        Dato obligatorio.
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="measuredPressure">
            <mat-header-cell *matHeaderCellDef> Presión Medida <br> [psi] </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">
                <mat-form-field>
                    <input matInput [readonly]="readOnlyContent" type="number" name="measuredPressure"
                        [(ngModel)]="annulusSpaces[i].measuredPressure"
                        (change)="enableSaveButton(i); onSectionTouched('annulusSpaces')"
                        [disabled]="!annulusSpace.hasMeasuredPressure" />
                    <mat-hint class="alert" *ngIf="annulusSpace.hasMeasuredPressure && !readOnlyContent">
                        Dato obligatorio.
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="annulusFluidBaseId">
            <mat-header-cell *matHeaderCellDef class="no-padding"> Base de Fluido <br>en Anular </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index" class="no-padding">
                <mat-form-field>
                    <mat-select name="annulusFluidBaseId" [(ngModel)]="annulusSpace.annulusFluidBaseId" (selectionChange)="enableSaveButton(i)" [disabled]="readOnlyContent" placeholder="Seleccionar">
                        <mat-option *ngFor="let base of annulusFluidBases" [value]="base.annulusFluidBaseId">
                            {{base.annulusFluidBaseName}}
                        </mat-option>
                    </mat-select>
                    <mat-hint>
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="averageDensity">
            <mat-header-cell *matHeaderCellDef> Densidad <br>Promedio [ppg] </mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index">
                <mat-form-field>
                    <input matInput inputmode="numeric" [(ngModel)]="annulusSpace.averageDensity" name="averageDensity" (change)="enableSaveButton(i)" [disabled]="readOnlyContent" [min]="0.001" digitOnly pattern="^\d+(\.\d{1,3})?$" [decimal]="true" />
                    <mat-hint>
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let annulusSpace; let i = index" [ngClass]="'mat-column-save'">
                <button mat-mini-fab (click)="openComments(annulusSpaces[i], i, $event, readOnlyContent);" class="comment-ho-icon" name="openComments">
                    <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
                    <div class="circle-comments" *ngIf="annulusSpaces[i].comments"></div>
                    <span  class = "comment">Comentar</span>
                </button>
                <button mat-mini-fab (click)="save(annulusSpaces[i], i);" class="save-ho-icon" [disabled]="isDisabled[i]" name="save">
                    <mat-icon class="material-icons-outlined">save</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="9">
                <div class="footer">
                    <div class="footer-no-data">No se encontraron datos.</div>
                    <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
                </div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>
    </table>


    <app-handover-detail-injector-wells [handover]="handover" [readOnlyContent]="readOnlyContent"
        *ngIf="showInjectorWells"
        (sectionTouched)="onSectionTouched($event)"
        (hasPendingChanges)="onInjectorWellsPendingChanges($event)">
    </app-handover-detail-injector-wells>

    <app-handover-detail-mandril  [handover]="handover"  [readOnlyContent]="readOnlyContent" *ngIf="isHO3">
    </app-handover-detail-mandril>
</div>
